import React, { Fragment, FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Table, TableHead, TableBody, TableCell, TableRow } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { UserFeedFollowGroupFragment } from 'api';
import { DummyTableRow, EmptyState, IEmptyState, Loaders, ResponsiveTable } from 'components';

import * as GroupRows from './GroupRows';

interface IProps {
  groups: UserFeedFollowGroupFragment[];
  emptyStateName: keyof IEmptyState;
  isExhausted?: boolean;
  sentinelRef?: (node: Element) => void;
}

const useStyles = makeStyles({
  borderCorrection: {
    width: 'calc(100% - 2px)',
  },
});

const GroupListFollow: FC<IProps> = props => {
  const { emptyStateName, groups, isExhausted, sentinelRef } = props;
  const { t } = useTranslation();
  const classes = useStyles();

  if (emptyStateName && !groups.length) {
    return <EmptyState name={emptyStateName} />;
  }

  return (
    <Fragment>
      <ResponsiveTable>
        <Table className={classes.borderCorrection}>
          <TableHead>
            <TableRow>
              <TableCell colSpan={3}>{t('common:name')}</TableCell>
              <TableCell colSpan={2}>{t('common:member_plural')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {groups.map((group, index) => (
              <Fragment key={group.id}>
                {!index && <DummyTableRow height={20} colSpan={4} />}
                <GroupRows.Client group={group} />
                <DummyTableRow height={20} colSpan={4} />
              </Fragment>
            ))}
          </TableBody>
        </Table>
      </ResponsiveTable>
      {!isExhausted && (
        <div ref={sentinelRef}>
          <Loaders.Standard />
        </div>
      )}
    </Fragment>
  );
};

GroupListFollow.defaultProps = {
  isExhausted: true,
};

export default GroupListFollow;
